import { render, staticRenderFns } from "./demoMessage.vue?vue&type=template&id=20f19cd6&scoped=true&"
var script = {}
import style0 from "./demoMessage.vue?vue&type=style&index=0&id=20f19cd6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f19cd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f19cd6')) {
      api.createRecord('20f19cd6', component.options)
    } else {
      api.reload('20f19cd6', component.options)
    }
    module.hot.accept("./demoMessage.vue?vue&type=template&id=20f19cd6&scoped=true&", function () {
      api.rerender('20f19cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/demoMessage/demoMessage.vue"
export default component.exports